import React from 'react';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import { getAIScoring, getBandScore, hasTeacherReviewedScore, shouldShowScore } from './utils/scoreHelpers';
import './SpeakingResults.css';

const criteria = [
  ['task_achievement', 'Task achievement', '#297B71'],
  ['coherence_and_cohesion', 'Coherence & cohesion', '#7450B8'],
  ['lexical_resource', 'Lexical resource', '#3978A6'],
  ['grammatical_range_and_accuracy', 'Grammar & accuracy', '#B46C35'],
];

export default function WritingResultsFrame({ children, apiResult, duration, durationLabel = 'Duration', teacherReviewContent }) {
  const ai = getAIScoring(apiResult);
  const scoreAvailable = shouldShowScore(apiResult);
  const band = getBandScore(apiResult, { preferManualScore: true });
  const teacherReviewed = hasTeacherReviewedScore(apiResult);

  return <section className="speaking-results" aria-label="IELTS Writing results">
    <div className="sr-main">
      <header className="sr-heading">
        <div><span className="sr-eyebrow">IELTS / WRITING</span><h2>Your writing results</h2></div>
        <span className="sr-status">{scoreAvailable ? (teacherReviewed ? 'Teacher reviewed' : 'Evaluation complete') : 'Pending evaluation'}</span>
      </header>
      <div className="sr-summary">
        <div className="sr-overall"><span>Overall band</span><div><strong>{scoreAvailable && band !== null ? band : '-'}</strong><span> / 9</span></div></div>
        <div className="sr-criteria">{criteria.map(([key, label, color]) => {
          const criterion = ai?.criteria?.[key];
          const score = typeof criterion === 'object' ? criterion?.score : criterion;
          const available = scoreAvailable && score !== null && score !== undefined && score !== '' && Number.isFinite(Number(score));
          return <div className="sr-criterion" key={key} style={{ '--criterion-color': color }}>
            <span>{label}</span><strong>{available ? score : '-'}</strong>
            <div className="sr-meter" aria-hidden="true"><i style={{ width: available ? `${Math.max(0, Math.min(9, Number(score))) / 9 * 100}%` : '0%' }} /></div>
            <small>{available ? 'AI band score' : 'Not available yet'}</small>
          </div>;
        })}</div>
      </div>
      {children}
    </div>
    <aside className="sr-sidebar" aria-label="Duration and writing feedback">
      {duration && <div className="sr-duration"><span className="sr-duration-icon" aria-hidden="true"><AccessTimeRoundedIcon /></span><div><span>{durationLabel}</span><strong>{duration}</strong></div></div>}
      {teacherReviewContent}
      {ai && scoreAvailable && <section className="sr-feedback" aria-label="Overall writing feedback">
        <div className="sr-section-heading"><h3>Overall writing feedback</h3>{ai.evaluation_confidence && <span className="sr-confidence" data-confidence={String(ai.evaluation_confidence).toLowerCase()}>AI confidence: {ai.evaluation_confidence}</span>}</div>
        {ai.reason && <p>{ai.reason}</p>}
        <div className="sr-feedback-grid">{criteria.map(([key, label, color]) => {
          const feedback = ai.criteria?.[key]?.feedback;
          const items = Array.isArray(feedback) ? feedback : typeof feedback === 'string' && feedback.trim() ? [feedback] : [];
          return <details key={key} style={{ '--criterion-color': color }}><summary>{label}</summary>{items.length ? <ul>{items.map((text, index) => <li key={index}>{text}</li>)}</ul> : <p>No specific feedback available.</p>}</details>;
        })}</div>
      </section>}
    </aside>
  </section>;
}
